const Territory = require('../../entities/Territory');
const { Age }  = require("../Constants");
const TerritoryNames = require("../Names/TerritoryNames");

class AutonomousTerritory extends Territory {
    constructor(){
        super(
            Age.Age2,
            TerritoryNames.AutonomousTerritory,
            "Gain 4 Science, 5 resources, 6 food, or 7 culture. In addition, gain a civil action, a military action, and lose 2 blue cubes.",
            {}
        )
    }
}

module.exports = AutonomousTerritory;